import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const CerezPolitikasiPage = lazy(() => import('../pages/cerez-politikasi/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />
  },
  {
    path: '/iletisim',
    element: <ContactPage />
  },
  {
    path: '/kvkk',
    element: <KVKKPage />
  },
  {
    path: '/cerez-politikasi',
    element: <CerezPolitikasiPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
